import React from 'react';
import { BrowserRouter, useHistory } from 'react-router-dom';

import { mountReactRoot } from 'utils/reactRoot';

import App from './App';

// Wrapper component to get history from BrowserRouter
const AppWrapper: React.FC = () => {
  const history = useHistory();
  return <App history={history} />;
};

const rootEl = document.getElementById('root');
if (rootEl) {
  mountReactRoot(
    <React.StrictMode>
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </React.StrictMode>,
    rootEl,
  );
}
